import React, { useState } from 'react';
import * as messages from '@radnuc/messages';

//import {Map, Marker, TileLayer, GeoJSON, Popup, ImageOverlay, Polygon, LayerGroup, withLeaflet, LayersControl, MapProps } from 'react-leaflet'
import * as reactleaflet from 'react-leaflet'
import L  from 'leaflet'
import PrintControlDefault from 'react-leaflet-easyprint'; //Make sure to replace npm installed react-leaflet-easyprint with one in components
import * as htmlToImage from 'html-to-image';
import Control from 'react-leaflet-control';
//import html2canvas from 'html2canvas';
import * as geojson from 'geojson';
import {BioInvestigation} from './BioInvestigationDisplay'
import TimeAgo from '@radnuc/react-ui-components/dist/TimeAgo'
//import { SimpleMapScreenshoter } from "leaflet-simple-map-screenshoter";

import { uuidToString } from '../utils/UUID';

import '@radnuc/react-ui-components/dist/MapDisplay.css'
import './MultiSensorMapDisplay.css'

import pin_industrial_logo from '@radnuc/react-ui-components/dist/img/pin-industrial.png'
import pin_medical_logo from '@radnuc/react-ui-components/dist/img/pin-medical.png'
import pin_nuclear_logo from '@radnuc/react-ui-components/dist/img/pin-nuclear.png'
import pin_norm_logo from '@radnuc/react-ui-components/dist/img/pin-norm.png'
import pin_biological_logo from '@radnuc/react-ui-components/dist/img/pin-biological.png'
import pin_chemical_logo from '@radnuc/react-ui-components/dist/img/pin-chemical.png'
import pin_biosigma_logo from './img/pin-biosigma.png'
import pin_generic_logo from '@radnuc/react-ui-components/dist/img/pin-generic-white-32.png'
import pin_generic_gray_logo from '@radnuc/react-ui-components/dist/img/pin-generic-gray.png'
import active_badge_logo from '@radnuc/react-ui-components/dist/img/active-investigation-badge.png'
import pin_shadown_logo from '@radnuc/react-ui-components/dist/img/marker-shadow.png'
import network_alert_logo from './img/icon-network-blue.png'
import location_circle_logo from '@radnuc/react-ui-components/dist/img/ic_my_location_48px.png'
import location_circle_white_logo from './img/ic_my_location_48px_white.png'
import estimated_release_loc_logo from './img/103431_cancel_icon.png'
import estimated_release_loc_white_logo from './img/103431_cancel_icon_white.png'
import location_vector_logo from '@radnuc/react-ui-components/dist/img/ic_navigation_48px-32.png'
import location_vector_white_logo from '@radnuc/react-ui-components/dist/img/ic_navigation_48px-32_white.png'
import recenter_logo from '@radnuc/react-ui-components/dist/img/gps-navi-arrow-circle-32_white.png'
import recenter_on_alert_logo from '@radnuc/react-ui-components/dist/img/warning-lock-48_white.png'
import recenter_disabled_logo from '@radnuc/react-ui-components/dist/img/unlock-48_white.png'
import map_day_logo from '@radnuc/react-ui-components/dist/img/sun-day-bright-light-48_white.png'
import map_night_logo from '@radnuc/react-ui-components/dist/img/weather-night-48_white.png'
import colorbar_logo from './img/colorbar_nolabel_only.png';
import map_fit_all from './img/map_fit_all.png'
//import test_dose_image from './img/balloon_festival_example.png'
import { DoseDatatype, DoseMapMessage } from '../BD21DataStream';
import { CBSigmaOutput } from '../BD21Device';

import { FakeImageData } from '../utils/FakeData'
import { DoseMapAnalysisDisplay, DoseMapAnalysisInterface, DoseMapTypesEnum } from './DoseMapDisplay';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;; //BioInvestigation;

const API_ROOT = window.app && window.app.env.API_URL;

export type SensorPosition = {
    device: string,
    timestamp: number,
    latitude: number | null,
    longitude: number | null,
    level: number | null,
}

export type DoseOverlayData = {
    dose_map_data: any,
    latitude_se: number,
    longitude_se: number,
    latitude_nw: number,
    longitude_nw: number,
}

interface InvestigationInterface {
    select: (key: Investigation) => void,
    unselect: () => void,
}

export interface MultiSensorMapDisplayProps {
    investigations: Investigation[],
    selectedInvestigation?: Investigation,
    investigationInterface: InvestigationInterface,
    liveStream: boolean,
    replayTime?: Date,
    sensorPositions: {[key: string]: SensorPosition},
    trackThisSensorLocation?: string | undefined,
    doseMap?: DoseMapMessage,
    cbSigmaArray?: CBSigmaOutput[] | undefined,
    doseMapAnalysisInterface?: DoseMapAnalysisInterface,
}

export interface MultiSensorMapDisplayState {
    keep_vehicle_centered: boolean,
    recenter_on_alert: boolean,
    map_mode_day: boolean,
    map_mode_day_simple: boolean,
    plot_since: number,
    zoom_level: number,
    zoom_level_replay: number,
    inv_selected: boolean
    display_dose_map: boolean,
    display_max_dose_map: boolean,
    display_uncertainty_map: boolean,
    dosemap_ready: boolean,
}

export class MultiSensorMapDisplay extends React.Component<MultiSensorMapDisplayProps, MultiSensorMapDisplayState> {
    //programmatic_map_control: boolean = false;
    map_element: React.RefObject<any>;
    map: L.Map | undefined;
    //last_location_message: messages.Core.GPSReading | undefined;
    last_sensor_locations: {[key: string]: SensorPosition} | undefined;
    initialized: boolean = false;
    inv_ongoing_centered:Map<String,NodeJS.Timeout> = new Map<String,NodeJS.Timeout>();
    dose_map_available: boolean = false;
    uncertainty_map_available: boolean = false;
    imageURLs: {[key: string]: {url: string, update_time: number}} = {};
    dosemap_ready = false;
    map_center: [number, number] | undefined = undefined;
    need_to_refresh_image_overlay: boolean = false;

    constructor(props: MultiSensorMapDisplayProps) {
        super(props)

        this.state = {
            keep_vehicle_centered: true,
            recenter_on_alert: true,
            map_mode_day: true,
            map_mode_day_simple: true,
            plot_since: 0,
            zoom_level: 13,
            zoom_level_replay: 17,
            inv_selected: false,
            display_dose_map: false,
            display_max_dose_map: false,
            display_uncertainty_map: false,
            dosemap_ready:false,
        }

        this.map_element = React.createRef<any>();

        this.handleUnselectButton = this.handleUnselectButton.bind(this);
        this.handleRecenterButtonClick = this.handleRecenterButtonClick.bind(this);
        this.handleRecenterOnAlertButtonClick = this.handleRecenterOnAlertButtonClick.bind(this);
        this.handleMapModeButtonClick = this.handleMapModeButtonClick.bind(this);
        this.handleDayMapTypeClick = this.handleDayMapTypeClick.bind(this);
        this.handleDoseMapButtonClick = this.handleDoseMapButtonClick.bind(this);
        this.handleMaxDoseMapButtonClick = this.handleMaxDoseMapButtonClick.bind(this);
        this.handleUncertaintyMapButtonClick = this.handleUncertaintyMapButtonClick.bind(this);
        this.calculateBoundsFromSensor = this.calculateBoundsFromSensor.bind(this);
        this.calculateBoundsFromInvestigations = this.calculateBoundsFromInvestigations.bind(this);
        this.clickOnDoseMapType = this.clickOnDoseMapType.bind(this);
        //this.handleClearTrailClick = this.handleClearTrailClick.bind(this);
    }

    componentDidMount() {
        this.patchMapTileGapBug();

        if(!this.initialized){
            if(this.getMapInitializedFromSessionStorage()){
                this.map_center = this.getMapCenterFromSessionStorage();
                this.setState({zoom_level: this.getMapZoomFromSessionStorage()});
                //this.setCurrentMapToSessionStorage()
                const this_map = this.map_element.current.leafletElement as L.Map;
                this_map.setZoom(this.getMapZoomFromSessionStorage());
                this.initialized = true;
                this.need_to_refresh_image_overlay = true;
            }
        }


    }

    componentWillUnmount(){
        this.setCurrentMapToSessionStorage();
    }

    componentDidUpdate(prevProps: MultiSensorMapDisplayProps) {
        //On first sensor locations
        if(Object.keys(this.props.sensorPositions).length > 0){
            if(!this.initialized){
                if(this.props.liveStream){
                    const this_map = this.map_element.current.leafletElement as L.Map;  //N.B. THIS IS HOW YOU GET MAP FROM MAP REFERENCE!!!!!!!!! **IMPORTANT**
                    this_map.fitBounds(this.calculateBoundsFromSensor(),{maxZoom:17})

                    this.setCurrentMapToSessionStorage();
                }

                this.initialized = true;
            }
        }
        /*
        if(this.need_map_refresh){
            this.clickOnDoseMapType(prevProps);
            this.need_map_refresh = false;
        }
        */
        //On New Investigation
        if (this.map_element.current !== null && this.props.investigations.length > prevProps.investigations.length) {
            const investigationsCurrentlyAlarming = this.props.investigations
                .filter((inv)=>{return (!inv.finalized);})
                .sort((lhs, rhs) => lhs.start_time - rhs.start_time);
            if(investigationsCurrentlyAlarming.length > 0){
                investigationsCurrentlyAlarming.forEach(inv => {
                    console.log(this.inv_ongoing_centered)
                    if(!this.inv_ongoing_centered.has(uuidToString(inv.id))){
                        console.log('New Inv '+uuidToString(inv.id))
                        //new investigation

                        if(this.state.recenter_on_alert && this.props.selectedInvestigation===undefined){
                            const this_map = this.map_element.current.leafletElement as L.Map;
                            //const bounds = this.calculateBoundsFromInvestigations([inv]);
                            if('type' in inv){
                                if(inv.source_location !== null){
                                    if (inv.source_location.latitude !== null && inv.source_location.longitude !== null) {
                                        const point = new L.LatLng(inv.source_location.latitude,inv.source_location.longitude)
                                        this_map.setView(point,this.state.zoom_level);
                                        const centerpt = this_map.getCenter()
                                        this.map_center = [centerpt.lat,centerpt.lng]
                                        console.log('Focusing on '+uuidToString(inv.id))
                                        console.log(this.inv_ongoing_centered)
                                    }
                                } else if(inv.vehicle_location !== null){
                                    if (inv.vehicle_location.latitude !== null && inv.vehicle_location.longitude !== null) {
                                        const point = new L.LatLng(inv.vehicle_location.latitude,inv.vehicle_location.longitude)
                                        this_map.setView(point,this.state.zoom_level);
                                        const centerpt = this_map.getCenter()
                                        this.map_center = [centerpt.lat,centerpt.lng]
                                        console.log('Focusing on '+uuidToString(inv.id))
                                        console.log(this.inv_ongoing_centered)
                                    }
                                }
                            }
                        }

                        const thisTimeoutFunc = ()=>{
                            thisTimeout = setTimeout(()=>{
                                const thisInvNow = this.props.investigations.filter((invNow)=>{
                                    if(uuidToString(invNow.id)){
                                        return (invNow);
                                    }
                                });
                                if(thisInvNow[0].finalized){
                                    clearTimeout(this.inv_ongoing_centered.get(uuidToString(inv.id)))
                                    this.inv_ongoing_centered.delete(uuidToString(inv.id));
                                    //console.log('finalized '+uuidToString(inv.id))
                                } else {
                                    thisTimeoutFunc();
                                    //console.log('restarting '+uuidToString(inv.id))
                                }
                            },1000)
                            return thisTimeout;
                        }
                        let thisTimeout:NodeJS.Timeout =thisTimeoutFunc();
                        this.inv_ongoing_centered.set(uuidToString(inv.id),thisTimeout);
                    }
                });
            } else {
                const this_map = this.map_element.current.leafletElement as L.Map;
                const centerpt = this_map.getCenter()
                this.map_center = [centerpt.lat,centerpt.lng]
            }
        }
        //On Tracking device change
        if(this.props.trackThisSensorLocation !== prevProps.trackThisSensorLocation && this.props.trackThisSensorLocation){
            const this_map = this.map_element.current.leafletElement as L.Map;  //N.B. THIS IS HOW YOU GET MAP FROM MAP REFERENCE!!!!!!!!! **IMPORTANT**
            const thisSensorPosition = this.props.sensorPositions[this.props.trackThisSensorLocation];
            if(thisSensorPosition){
                if(thisSensorPosition.latitude !== null && thisSensorPosition.longitude !== null){
                    const point = L.latLng(thisSensorPosition.latitude,thisSensorPosition.longitude)
                    this_map.flyTo(point,17)
                }
            }
        }

        //On Select Investigation Change
        if(this.props.selectedInvestigation !== prevProps.selectedInvestigation){
            if(this.props.selectedInvestigation !== undefined){
                if(this.props.selectedInvestigation.vehicle_location === null){
                    if('type' in this.props.selectedInvestigation && this.props.selectedInvestigation.source_location !== null){
                        if (this.props.selectedInvestigation.source_location.latitude !== null && this.props.selectedInvestigation.source_location.longitude !== null) {
                            this.map_center= [this.props.selectedInvestigation.source_location.latitude, this.props.selectedInvestigation.source_location.longitude];
                            const this_map = this.map_element.current.leafletElement as L.Map;
                            this_map.setView(this.map_center,this.state.zoom_level_replay)
                            const centerpt = this_map.getCenter()
                            this.map_center = [centerpt.lat,centerpt.lng]
                        }
                    }
                } else {
                    if (this.props.selectedInvestigation.vehicle_location.latitude !== null && this.props.selectedInvestigation.vehicle_location.longitude !== null) {
                        this.map_center = [this.props.selectedInvestigation.vehicle_location.latitude, this.props.selectedInvestigation.vehicle_location.longitude];
                        const this_map = this.map_element.current.leafletElement as L.Map;
                        this_map.setView(this.map_center,this.state.zoom_level_replay)
                        const centerpt = this_map.getCenter()
                        this.map_center = [centerpt.lat,centerpt.lng]
                    }
                }
            } else {
                //const this_map = this.map_element.current.leafletElement as L.Map;
                //this_map.setView(this.map_center,this.state.zoom_level)
            }
        }

        //TODO TRIGGER THIS FOR ALL DOSE MAP THRESHOLD CHANGE
        const thisDoseMapType = this.props.doseMapAnalysisInterface?.doseMapType;
        /*
        if(this.props.doseMap?.doseMapMax !== prevProps.doseMap?.doseMapMax || this.props.doseMap?.doseMapMin !== prevProps.doseMap?.doseMapMin ||
            this.props.doseMap?.doseMaxMapMax !== prevProps.doseMap?.doseMaxMapMax || this.props.doseMap?.doseMaxMapMin !== prevProps.doseMap?.doseMaxMapMin ||
            this.props.doseMap?.uncertMapMax !== prevProps.doseMap?.uncertMapMax || this.props.doseMap?.uncertMapMin !== prevProps.doseMap?.uncertMapMin){
        */

        if(this.props.doseMap?.displayScaleVal[DoseDatatype.DOSE_RATE].max !== prevProps.doseMap?.displayScaleVal[DoseDatatype.DOSE_RATE].max ||
            this.props.doseMap?.displayScaleVal[DoseDatatype.DOSE_RATE].min !== prevProps.doseMap?.displayScaleVal[DoseDatatype.DOSE_RATE].min ||
            this.props.doseMap?.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].max !== prevProps.doseMap?.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].max ||
            this.props.doseMap?.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].min !== prevProps.doseMap?.displayScaleVal[DoseDatatype.MAX_DOSE_RATE].min ||
            this.props.doseMap?.displayScaleVal[DoseDatatype.UNCERTAINTY].max !== prevProps.doseMap?.displayScaleVal[DoseDatatype.UNCERTAINTY].max ||
            this.props.doseMap?.displayScaleVal[DoseDatatype.UNCERTAINTY].min !== prevProps.doseMap?.displayScaleVal[DoseDatatype.UNCERTAINTY].min ){

            for (const key in this.imageURLs) {
                URL.revokeObjectURL(this.imageURLs[key].url);
            }
            this.imageURLs = {};
            this.setState(() => ({
                dosemap_ready: false
            }));
        }


        if(this.props.doseMap !== prevProps.doseMap){
            this.need_to_refresh_image_overlay = true;
        }

        if(this.props.doseMapAnalysisInterface?.doseMapType !== prevProps.doseMapAnalysisInterface?.doseMapType || this.need_to_refresh_image_overlay){
            this.clickOnDoseMapType(prevProps, this.need_to_refresh_image_overlay);
            this.need_to_refresh_image_overlay = false;
        }

        if(this.props.doseMapAnalysisInterface?.doseMapSelected !== prevProps.doseMapAnalysisInterface?.doseMapSelected){
            console.log('doseMap changed to '+this.props.doseMapAnalysisInterface?.doseMapSelected)
            if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAP){
                this.handleDoseMapButtonClick(true);
            }
            if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAX){
                this.handleMaxDoseMapButtonClick(true);
            }
            if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.UNCERTAINTY){
                if(this.props.doseMapAnalysisInterface?.doseMapSelected === 'C'){
                    this.handleUncertaintyMapButtonClick();
                } else {
                    this.handleUncertaintyMapButtonClick(true);
                }
            }
        }

    }

    clickOnDoseMapType(prevProps: MultiSensorMapDisplayProps, flag?:boolean){
        if(flag === false || flag === undefined){
            flag = undefined;
        }
        if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAP){
            this.handleDoseMapButtonClick(flag);
        }
        if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAX){
            this.handleMaxDoseMapButtonClick(flag);
        }
        if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.UNCERTAINTY){
            this.handleUncertaintyMapButtonClick(flag);
        }
        if(this.props.doseMapAnalysisInterface?.doseMapType === undefined){
            if(prevProps.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAP){
                this.handleDoseMapButtonClick();
            }
            if(prevProps.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAX){
                this.handleMaxDoseMapButtonClick();
            }
            if(prevProps.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.UNCERTAINTY){
                this.handleUncertaintyMapButtonClick();
            }
        }
    }

    static clearMapInfoSessionStorage(){
        window.sessionStorage.removeItem('session_map_initialized');
        window.sessionStorage.removeItem('session_map_center_lat');
        window.sessionStorage.removeItem('session_map_center_lon');
        window.sessionStorage.removeItem('session_map_center_zoom');
    }

    setCurrentMapToSessionStorage(){

        if(this.initialized){
            const this_map = this.map_element.current.leafletElement as L.Map;
            window.sessionStorage.setItem('session_map_initialized','true'); //this.initialized?'true':'false');
            window.sessionStorage.setItem('session_map_center_lat',this_map.getCenter().lat.toFixed(8));
            window.sessionStorage.setItem('session_map_center_lon',this_map.getCenter().lng.toFixed(8));
            window.sessionStorage.setItem('session_map_center_zoom',this_map.getZoom().toFixed(0));
        }
    }
    getMapInitializedFromSessionStorage(){
        const session_map_initialized = window.sessionStorage.getItem('session_map_initialized');
        if(session_map_initialized===null){
            return false
        } else if(session_map_initialized==='true'){
            return true
        } else {
            return false
        }
    }
    getMapCenterFromSessionStorage(){
        let result:[number, number] | undefined;
        const session_map_center_lat = Number(window.sessionStorage.getItem('session_map_center_lat'));
        const session_map_center_lon = Number(window.sessionStorage.getItem('session_map_center_lon'));
        if(session_map_center_lat !== null && session_map_center_lon !== null)
            result = [session_map_center_lat,session_map_center_lon];
        else
            result = [0,0]

        return(result);
    }
    getMapZoomFromSessionStorage(){
        const session_map_zoom = window.sessionStorage.getItem('session_map_center_zoom');
        if(session_map_zoom !== null){
            return Number(session_map_zoom)
        } else {
            return 13
        }
    }

    calculateBoundsFromSensor(){
        const uninitialized_val = 1000;
        let max_pos_lat:number = uninitialized_val;
        let min_pos_lat:number = uninitialized_val;
        let max_pos_lon:number  = uninitialized_val;
        let min_pos_lon:number  = uninitialized_val;
        let num_pos = 0;
        Object.values(this.props.sensorPositions).forEach((loc) => {
            if(loc.latitude !== null && loc.longitude !== null){
                if(max_pos_lat === uninitialized_val || min_pos_lat === uninitialized_val ||
                    max_pos_lon === uninitialized_val || min_pos_lon === uninitialized_val){
                    max_pos_lat = min_pos_lat = loc.latitude;
                    max_pos_lon = min_pos_lon = loc.longitude;
                    num_pos += 1;
                } else {
                    if(max_pos_lat < loc.latitude){
                        max_pos_lat = loc.latitude;
                    }
                    if(min_pos_lat > loc.latitude){
                        min_pos_lat = loc.latitude;
                    }
                    if(max_pos_lon < loc.longitude){
                        max_pos_lon = loc.longitude;
                    }
                    if(min_pos_lon > loc.longitude){
                        min_pos_lon = loc.longitude;
                    }

                }
            }
        });
        if(max_pos_lat === uninitialized_val || min_pos_lat === uninitialized_val){
            if(API_ROOT.DefaultMapCenter && API_ROOT.DefaultMapCenter.lat && API_ROOT.DefaultMapCenter.lon){
                max_pos_lat = API_ROOT.DefaultMapCenter.lat+0.1;
                min_pos_lat = API_ROOT.DefaultMapCenter.lat-0.1;
                max_pos_lon = API_ROOT.DefaultMapCenter.lon+0.1;
                min_pos_lon = API_ROOT.DefaultMapCenter.lon-0.1;
            } else {
                max_pos_lat = min_pos_lat = 0;
                max_pos_lon = min_pos_lon = 0;

            }
        }

        const corner1 = L.latLng(max_pos_lat,max_pos_lon)
        const corner2 = L.latLng(min_pos_lat, min_pos_lon);
        let bounds = L.latLngBounds(corner1, corner2);
        return bounds;
    }

    calculateBoundsFromInvestigations(inv:Investigation[]){
        const uninitialized_val = 1000;
        let max_pos_lat:number = uninitialized_val;
        let min_pos_lat:number = uninitialized_val;
        let max_pos_lon:number  = uninitialized_val;
        let min_pos_lon:number  = uninitialized_val;
        let num_pos = 0;
        Object.values(inv).forEach((inv) => {
            if('type' in inv){
                //Only for encounter types
                const loc = inv.source_location;
                if(loc.latitude !== null && loc.longitude !== null){
                    if(max_pos_lat === uninitialized_val || min_pos_lat === uninitialized_val ||
                        max_pos_lon === uninitialized_val || min_pos_lon === uninitialized_val){
                        max_pos_lat = min_pos_lat = loc.latitude;
                        max_pos_lon = min_pos_lon = loc.longitude;
                        num_pos += 1;
                    } else {
                        if(max_pos_lat < loc.latitude){
                            max_pos_lat = loc.latitude;
                        }
                        if(min_pos_lat > loc.latitude){
                            min_pos_lat = loc.latitude;
                        }
                        if(max_pos_lon < loc.longitude){
                            max_pos_lon = loc.longitude;
                        }
                        if(min_pos_lon > loc.longitude){
                            min_pos_lon = loc.longitude;
                        }

                    }
                }
            }
        });
        const corner1 = L.latLng(max_pos_lat,max_pos_lon)
        const corner2 = L.latLng(min_pos_lat, min_pos_lon);
        let bounds = L.latLngBounds(corner1, corner2);
        return bounds;
    }

    centerOnAlert(){
        this.setState(() => ({
            keep_vehicle_centered: true
        }));
        //this.props.investigationInterface.unselect();
    }

    enableRecenterButton() {
        if (this.last_sensor_locations !== undefined) {
            this.setState(() => ({
                keep_vehicle_centered: false
            }));
        }
    }

    getZoom(event: L.LayersControlEvent) {
        if(this.props.selectedInvestigation){
            this.setState(() => ({
                zoom_level_replay: event.target.getZoom(),
            }));
        } else {
            this.setState(() => ({
                zoom_level: event.target.getZoom(),
            }));
        }
    }

    handleUnselectButton(event: React.MouseEvent<HTMLElement>) {
        this.props.investigationInterface.unselect();
        this.setState(() => ({
            keep_vehicle_centered: true
        }));
    }

    handleRecenterButtonClick(event: React.MouseEvent<HTMLElement>) {
        this.props.investigationInterface.unselect();
        this.setState(() => ({
            keep_vehicle_centered: true
        }));
    }

    handleRecenterOnAlertButtonClick(event: React.MouseEvent<HTMLElement>) {
        this.setState(() => ({
            recenter_on_alert: !this.state.recenter_on_alert
        }));
    }

    handleMapModeButtonClick(event: React.MouseEvent<HTMLElement>) {
        this.setState(() => ({
            map_mode_day: !this.state.map_mode_day
        }));
    }

    handleDayMapTypeClick(isSimple: boolean){
        this.setState(() => ({
            map_mode_day_simple: isSimple
        }));
    }
    /*
    handleDoseMapUnselectClick(){
        for (const key in this.imageURLs) {
            URL.revokeObjectURL(this.imageURLs[key].url);
        }
        this.imageURLs = {};
        this.dosemap_ready = false;
    }
    */

    handleDoseMapToolButtonClick(event: React.MouseEvent<HTMLElement>) {
        this.props.doseMapAnalysisInterface?.setControlDisplayOpen(!this.props.doseMapAnalysisInterface.doseMapControlOpen);
    }

    handleDoseMapButtonClick(flag?:boolean){
        if(flag){
            this.setState(() => ({
                display_dose_map: flag,
                display_uncertainty_map: !flag,
                display_max_dose_map: !flag,
            }));
        } else {
            if(this.dose_map_available){
                if(!this.state.display_dose_map === true){
                    const setting_display_uncertainty_map = false;
                    this.setState(() => ({
                        display_uncertainty_map: setting_display_uncertainty_map,
                        display_max_dose_map: false,
                    }));
                }
                this.setState(() => ({
                    display_dose_map: !this.state.display_dose_map,
                }));
                //console.log('click dose map button, state:'+!this.state.display_dose_map)
            }
        }

        for (const key in this.imageURLs) {
            URL.revokeObjectURL(this.imageURLs[key].url);
        }
        this.imageURLs = {};
    }

    handleMaxDoseMapButtonClick(flag?:boolean){
        if(flag){
            this.setState(() => ({
                display_dose_map: !flag,
                display_uncertainty_map: !flag,
                display_max_dose_map: flag,
            }));
        } else {
            if(this.dose_map_available){
                if(!this.state.display_max_dose_map === true){
                    const setting_display_uncertainty_map = false;
                    this.setState(() => ({
                        display_uncertainty_map: setting_display_uncertainty_map,
                        display_dose_map: false,
                    }));
                }
                this.setState(() => ({
                    display_max_dose_map: !this.state.display_max_dose_map,
                }));
                //console.log('click dose map button, state:'+!this.state.display_dose_map)
            }
        }
        for (const key in this.imageURLs) {
            URL.revokeObjectURL(this.imageURLs[key].url);
        }
        this.imageURLs = {};
    }

    handleUncertaintyMapButtonClick(flag?:boolean){
        if(flag){
            this.setState(() => ({
                display_dose_map: !flag,
                display_uncertainty_map: flag,
                display_max_dose_map: !flag,
            }));
        } else {
            if(this.uncertainty_map_available){
                if(!this.state.display_uncertainty_map === true){
                    const setting_display_dose_map = false;
                    this.setState(() => ({
                        display_dose_map: setting_display_dose_map,
                        display_max_dose_map: false,
                    }));
                }
                this.setState(() => ({
                    display_uncertainty_map: !this.state.display_uncertainty_map,
                }));
                console.log('click uncertainty button, state:'+!this.state.display_uncertainty_map)
            } else {
                //Nothing to display
                this.setState(() => ({
                    display_dose_map: false,
                    display_uncertainty_map: false,
                    display_max_dose_map: false,
                }));
            }
        }
        for (const key in this.imageURLs) {
            URL.revokeObjectURL(this.imageURLs[key].url);
        }
        this.imageURLs = {};
    }
    /*
    handleClearTrailClick(){
        if(this.props.positions.length > 1){
            this.setState(() => ({
                plot_since: this.props.positions[this.props.positions.length-2].time
            }));
        } else if (this.props.positions.length === 1){
            this.setState(() => ({
                plot_since: this.props.positions[this.props.positions.length-1].time
            }));
        }
    }
    */
    patchMapTileGapBug() {
        // Workaround for 1px lines appearing in some browsers due to fractional transforms
        // and resulting anti-aliasing. adapted from @cmulders' solution:
        // https://github.com/Leaflet/Leaflet/issues/3575#issuecomment-150544739
        let originalInitTile = (L.GridLayer.prototype as any)._initTile;
        if (originalInitTile.isPatched) return;
        L.GridLayer.include({
            _initTile: function (tile: any) {
                originalInitTile.call(this, tile);

                const tileSize = this.getTileSize();

                tile.style.width = tileSize.x + 1 + 'px';
                tile.style.height = tileSize.y + 1 + 'px';
            }
        });
        (L.GridLayer.prototype as any)._initTile.isPatched = true;
    }

    findCBSigmaAtTime(this_time:Date){
        let best_CBSigma;
        const this_timestamp = this_time.getTime();
        if(this.props.cbSigmaArray != undefined){
            if (this.props.cbSigmaArray.length > 0) {
                let min_time_diff = 100000;//new Date(this.props.positions[this.props.positions.length-1].time).getTime() - this_timestamp;
                this.props.cbSigmaArray.forEach(cbSigmaOutput => {
                    if(cbSigmaOutput !== undefined){
                        if((cbSigmaOutput.algorithmState !== messages.CBSigmaReport.AlgorithmState.DID_NOT_PROCESS &&
                            cbSigmaOutput.algorithmState !== messages.CBSigmaReport.AlgorithmState.DETECTING_NO_UPDATE) && cbSigmaOutput.isDetecting){
                            const cbSigmaOutputTimestamp_ms = cbSigmaOutput.timestamp; //*1000;
                            const this_time_diff = this_timestamp - cbSigmaOutputTimestamp_ms;
                            if(this_time_diff < min_time_diff && this_time_diff > 0){
                                best_CBSigma = cbSigmaOutput;
                                min_time_diff = this_time_diff
                            }
                        }
                    }
                });
            }
        }
        return best_CBSigma;
    }

    getInvOngoingCBSIGMA(investigations:Investigation[]){
        return investigations.filter((inv)=>{
                if('type' in inv){
                    if((inv.type === messages.Encounter.EncounterType.BIOSIGMA || inv.type === messages.Encounter.EncounterType.CHEMSIGMA) && !inv.finalized){
                        return true;
                    }
                }
                return false;
            });
    }
    /*
    async isDoseMapReady(){
        if(Object.keys(this.imageURLs).length > 0){
            const this_url = Object.values(this.imageURLs)[0].url;
            const result = await this.checkBlobUrl(this_url)
            console.log('isDoseMapReady result ' + result)
            this.dosemap_ready = true;
            this.render();
            return result;
        } else {
            return false;
        }
    }
    async checkBlobUrl(url:string):Promise<boolean> {
        return fetch(url)
        .then(response => true)
        .catch(() => false);

    }
    */

/*
    centerOnInvestigations(){
        const this_map = this.map_element.current.leafletElement as L.Map;
        const investigationsCurrentlyAlarming = this.props.investigations.filter((inv)=>{
                return (!inv.finalized);
            });


        if(this.map_element.current !== null){
                    const this_map = this.map_element.current.leafletElement as L.Map;
            if(investigationsCurrentlyAlarming.length > 0){
                const bounds = this.calculateBoundsFromInvestigations(investigationsCurrentlyAlarming)
                this_map.fitBounds(bounds);
            }
        }
    }
*/
    render() {


        //console.log('render @ '+Date.now())
        let keep_vehicle_centered = this.state.keep_vehicle_centered;
        let position: [number, number] | undefined;

        //var current_location_message;

        //TODO pick optimal position when nothing is selected
        if (this.props.sensorPositions !== undefined) {
            if(this.props.trackThisSensorLocation !== undefined){
                const this_sensor_loc = this.props.sensorPositions[this.props.trackThisSensorLocation];
                if(this_sensor_loc){
                    const this_lat = this_sensor_loc.latitude;
                    const this_lon = this_sensor_loc.longitude;
                    if(this_lat !== null && this_lon !== null){
                        position = [this_lat,this_lon];
                    }
                }
            }
            //don't track avg posigion
            /*
            else {
                let avg_pos_lat = 0;
                let avg_pos_lon = 0;
                let num_pos = 0;
                Object.values(this.props.sensorPositions).forEach((loc) => {
                    if(loc.latitude !== null && loc.longitude !== null){
                        if(loc.latitude !== 0 && loc.longitude !== 0){
                            avg_pos_lat += loc.latitude;
                            avg_pos_lon += loc.longitude;
                            num_pos += 1;
                        }
                    }
                });
                if(num_pos >0){
                    avg_pos_lat = avg_pos_lat/num_pos;
                    avg_pos_lon = avg_pos_lon/num_pos;
                    position = [avg_pos_lat,avg_pos_lon];
                    this.last_sensor_locations = this.props.sensorPositions;
                }
            }
            */
        }


        let zoom_level = this.state.zoom_level;
        if (this.props.selectedInvestigation) {
            zoom_level = this.state.zoom_level_replay;
            if(this.props.selectedInvestigation.vehicle_location === null){
                if('type' in this.props.selectedInvestigation && this.props.selectedInvestigation.source_location !== null){
                    if (this.props.selectedInvestigation.source_location.latitude !== null && this.props.selectedInvestigation.source_location.longitude !== null) {
                        position = [this.props.selectedInvestigation.source_location.latitude, this.props.selectedInvestigation.source_location.longitude];
                    }
                }
            } else {
                if (this.props.selectedInvestigation.vehicle_location.latitude !== null && this.props.selectedInvestigation.vehicle_location.longitude !== null) {
                    position = [this.props.selectedInvestigation.vehicle_location.latitude, this.props.selectedInvestigation.vehicle_location.longitude];
                }
            }
        }

        //let map_center: [number, number] | undefined;
        if (this.state.keep_vehicle_centered || this.props.selectedInvestigation) {
            //map_center = position;
            if(this.props.selectedInvestigation){
                this.map_center = position;
            }
        }
        //If map uninitialized, set mapt center to 0,0
        if (this.map_center === undefined && !this.initialized) {
            if(this.getMapInitializedFromSessionStorage()){
                this.map_center = this.getMapCenterFromSessionStorage();
                zoom_level = this.getMapZoomFromSessionStorage();
            } else {
                if(API_ROOT.DefaultMapCenter && API_ROOT.DefaultMapCenter.lat && API_ROOT.DefaultMapCenter.lon){
                    this.map_center = [API_ROOT.DefaultMapCenter.lat, API_ROOT.DefaultMapCenter.lon];
                } else {
                    this.map_center = [0, 0];
                }
            }
            //// HACK
            //map_center = [39.798454391208544, -86.2619529390734]  //SPEEDWAY
        }

        let zoom_behavior: boolean | "center" = true;
        if (keep_vehicle_centered) {
            zoom_behavior = "center";
            //zoom_behavior = true;
        }
        let scrollwheel_zoom_behavior: boolean | "center" = true;
        if (keep_vehicle_centered) {
            scrollwheel_zoom_behavior = true;
        }

        let unselectButton;
        if (this.props.selectedInvestigation) {
            unselectButton =
                <div className="round-button" style={{ position: 'absolute', left: '55px', top: '10px', padding: '5px' }} onClick={this.handleUnselectButton}>
                    <img src={pin_generic_logo} alt="Marker"/> <div style={{ width: '5px' }}> </div>UNSELECT
                </div>
        }

        let recenterButton;
        /*
        if ((!this.state.keep_vehicle_centered && this.last_sensor_locations !== undefined) || this.props.selectedInvestigation) {
            recenterButton =
                <div className="round-button" style={{ position: 'absolute', left: '0px', bottom: '2px', padding: '5px' }} onClick={this.handleRecenterButtonClick}>
                    <img src={location_circle_white_logo} alt="Recenter" /> <div style={{ width: '5px' }}> </div>RESUME TRACKING
                </div>
        }
        */

        //Recenter on Alert button
        let recenter_status_img;
        if (this.state.recenter_on_alert) {
            recenter_status_img = recenter_on_alert_logo;
        } else {
            recenter_status_img = recenter_disabled_logo;
        }
        const recenterOnAlertButton =
            <div className="round-button" style={{ padding: '5px' }} onClick={this.handleRecenterOnAlertButtonClick}>
                <img src={recenter_status_img} alt="Recenter" />
            </div>


        //MapMode Button
        let map_mode_img;
        let map_url;
        let map_attribution:string;
        if (this.state.map_mode_day) {
            if(this.state.map_mode_day_simple){
                map_mode_img = map_day_logo;
                //map_url = 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png';
                //map_url = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                //map_attribution = 'Map tiles by Carto, under CC BY 3.0. Data by OpenStreetMap, under ODbL';

                if(API_ROOT.MapTileServer && API_ROOT.MapTileServer.map_url && API_ROOT.MapTileServer.attribution){
                    map_url = API_ROOT.MapTileServer.map_url;
                    map_attribution = API_ROOT.MapTileServer.attribution;
                } else {
                    //Default
                    map_url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    map_attribution = "&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                }

            } else {
                map_mode_img = map_day_logo;
                if(API_ROOT.MapTileServer && API_ROOT.MapTileServer.map_url && API_ROOT.MapTileServer.attribution){
                    map_url = API_ROOT.MapTileServer.map_url;
                    map_attribution = API_ROOT.MapTileServer.attribution;
                } else {
                    //Default
                    map_url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    map_attribution = "&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                }
            }
        } else {
            map_mode_img = map_night_logo;
            if(API_ROOT.MapTileServer && API_ROOT.MapTileServer.map_url && API_ROOT.MapTileServer.attribution){
                map_url = API_ROOT.MapTileServer.map_url;
                map_attribution = API_ROOT.MapTileServer.attribution;
            } else {
                //Default
                map_url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                map_attribution = "&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            }

            //map_url = "https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png";
            //map_attribution = "Map tiles by Carto, under CC BY 3.0. Data by OpenStreetMap, under ODbL";
        }

        const mapModeButton =
            <div className="round-button" style={{ padding: '5px' }} onClick={this.handleMapModeButtonClick}>
                <img src={map_mode_img} alt="Day/Night Toggle" />
            </div>
        let background_color;
        if (this.state.map_mode_day) {
            background_color = 'white';
        } else {
            background_color = 'black';
        }

        const doseMapToolButton =
            <div className="round-button" style={{margin: '5px', padding: '5px', width:'70px',fontSize:'0.8em'}} onClick={this.handleDoseMapToolButtonClick}>
                            <div>DOSE RATE MAP</div>
            </div>



        let cbsigma_contours;
        let cbsigma_release_loc;
        let cbsigma_contour_key;
        let cbsigma_release_time;
        if(this.props.cbSigmaArray !== undefined){
            let thisCBSigmaOutput;
            if(this.props.replayTime){
                thisCBSigmaOutput = this.findCBSigmaAtTime(this.props.replayTime);
            } else {
                if(this.getInvOngoingCBSIGMA(this.props.investigations).length > 0){
                    thisCBSigmaOutput = this.props.cbSigmaArray[0];
                }
            }
            if(thisCBSigmaOutput !== undefined){
                if(thisCBSigmaOutput.estimatedReleaseTimestamp !== null && thisCBSigmaOutput.estimatedReleaseTimestamp > 0){
                    cbsigma_contours = <CBSigmaContourDisplay cbSigmaOutput={thisCBSigmaOutput}/>
                    cbsigma_release_loc = <CBSigmaReleaseLocDisplay cbSigmaOutput={thisCBSigmaOutput} darkmap={!this.state.map_mode_day}/>

                    cbsigma_contour_key = <CBSigmaContourKeyDisplay cbSigmaOutput={thisCBSigmaOutput} darkmap={!this.state.map_mode_day}/>
                }
            }
        }

        //let current_locations = <MultiPositionMarkerDisplay locations={this.props.sensorPositions} mapModeDay={this.state.map_mode_day} />

        let doseMapOverlay:JSX.Element[] = [];
        //let colorbarValueLabelDisplay:JSX.Element[] = [];
        let doseMapLabel="";
        let doseMapButtonClass = "unavailable";
        let maxDoseMapButtonClass = "unavailable";
        let uncertMapButtonClass = "unavailable";
        this.dose_map_available = false;
        this.uncertainty_map_available = false;
        if(this.props.doseMap !== undefined){
            if(this.props.doseMap.regions !== undefined && this.props.doseMap.regions !== null && this.props.doseMap.regions.length > 0){

                let used_uuids: string[] = [];
                this.props.doseMap.regions.forEach(region => {
                    if(region.doseMap !== null){
                        doseMapButtonClass = "available";
                        maxDoseMapButtonClass = "available";
                        this.dose_map_available = true;
                    }
                    if(region.uncertMap !== null){
                        uncertMapButtonClass = "available";
                        this.uncertainty_map_available = true;
                    }

                    if(this.dose_map_available || this.uncertainty_map_available){
                        let imageData;
                        if(this.state.display_dose_map){
                            imageData = region.doseMap as unknown as Uint8Array;
                            doseMapButtonClass = " showing";
                            doseMapLabel = "Dose Map [uR/hr]"
                        } else if (this.state.display_uncertainty_map){
                            imageData = region.uncertMap as unknown as Uint8Array;
                            uncertMapButtonClass = " showing"
                            doseMapLabel = "Uncertainty Map [uR/hr]"
                        } else if (this.state.display_max_dose_map){
                            imageData = region.maxDoseMap as unknown as Uint8Array;
                            maxDoseMapButtonClass = " showing"
                            doseMapLabel = "Dose Map [uR/hr]"
                        }
                        if(imageData !== undefined){
                            let key = region.uuid || "default";
                            let imageUrl = null;
                            if (key in this.imageURLs && this.imageURLs[key].update_time >= (region.time || 0)) {
                                imageUrl = this.imageURLs[key].url;
                                used_uuids.push(key);
                            } else {
                                //console.log("Update tile", region.uuid);
                                const blob = new Blob([imageData], { type: "image/jpeg" });
                                imageUrl = URL.createObjectURL(blob);
                                this.imageURLs[key] = {url: imageUrl, update_time: region.time || 0};
                                used_uuids.push(key)
                            }

                            if(region.swCorner.lat !== null && region.swCorner.lon !== null && region.neCorner.lat !== null && region.neCorner.lon !== null){
                                let key2 = region.time!.toFixed() +'_'+ region.uuid;
                                let this_overlay = <reactleaflet.ImageOverlay key={key2} url={imageUrl}
                                                        bounds={new L.LatLngBounds(L.latLng(region.swCorner.lat, region.swCorner.lon),
                                                                                   L.latLng(region.neCorner.lat, region.neCorner.lon))} opacity={0.4}/>
                                doseMapOverlay.push(this_overlay);
                            }
                        }
                    }
                });

                let to_delete: string[] = [];
                for (const key in this.imageURLs) {
                    if (used_uuids.indexOf(key) === -1) {
                        URL.revokeObjectURL(this.imageURLs[key].url);
                        to_delete.push(key)
                        //console.log('deleting url: '+key)
                    }
                }
                to_delete.forEach((key) => delete this.imageURLs[key]);

            }
        }

        let doseRateMapButton;
        let uncertaintyMapButton;
        let maxDoseRateMapButton;

        let marker_opacity = 1.0;
        if(this.props.doseMapAnalysisInterface?.doseMapHideAlertPins){
            marker_opacity = 0.1;
        }
        let current_locations;
        let bioInvestigationMarkerDisplay;
        if(!this.props.doseMapAnalysisInterface?.doseMapHideAlertPins===true){
            bioInvestigationMarkerDisplay =
                <BioInvestigationMarkerDisplay
                    investigations={this.props.investigations}
                    selectedInvestigation={this.props.selectedInvestigation}
                    investigationInterface={this.props.investigationInterface}
                />
            current_locations = <MultiPositionMarkerDisplay locations={this.props.sensorPositions} mapModeDay={this.state.map_mode_day} />
        }

        if(API_ROOT.Modalities.RadDoseMap){

        }

        /*
        let darkMapMode;
        if(this.state.map_mode_day !== true){
            darkMapMode = "darkmapmode";
        }
        */

        const printControlCallback = (mapblob:Blob)=>{
            const d = new Date(Date.now());
            const datestring = d.toLocaleString("en-us", {month: "short"})+'_'+d.getDate()+'_'+d.getFullYear();
            const timestring = d.toLocaleString('en-US', {hour:'numeric',minute:'numeric',second:'numeric',hour12: true }).replace(/:/g,"_").replace(" ","_");
            const screencapture_filename = "screencapture_"+datestring+"_"+timestring+'.png';

            const saveImage = () => {
                let link = document.createElement('a');
                link.download = screencapture_filename;
                link.href = canvas.toDataURL()
                link.click();
            }

            const this_map = this.map_element.current.leafletElement as L.Map;  //N.B. THIS IS HOW YOU GET MAP FROM MAP REFERENCE!!!!!!!!! **IMPORTANT**
            const bound_corners = this_map!.getBounds();
            const ne_corner = bound_corners.getNorthEast();
            const nw_corner = bound_corners.getNorthWest();
            const sw_corner = bound_corners.getSouthWest();
            const hextent = nw_corner.distanceTo(ne_corner);
            const vextent = nw_corner.distanceTo(sw_corner);

            const meta_corners_string1 = "NE Corner: "+ne_corner.lat .toFixed(6)+','+ne_corner.lng.toFixed(6)
            const meta_corners_string2 = "SW Corner: "+sw_corner.lat .toFixed(6)+','+sw_corner.lng.toFixed(6)
            const map_center = this_map!.getCenter();
            const meta_map_center = "Center: "+map_center.lat.toFixed(6)+','+map_center.lng.toFixed(6)
            let meta_map_extent='';
            if(hextent < 1000 || vextent < 1000){
                meta_map_extent = "Area: "+hextent.toFixed(0)+'m (v) x '+vextent.toFixed(0)+'m (h)'
            } else if(hextent < 10000 || vextent < 10000){
                meta_map_extent = "Area: "+(hextent/1000).toFixed(1)+'km (v) x '+(vextent/1000).toFixed(1)+'km (h)'
            } else {
                meta_map_extent = "Area: "+(hextent/1000).toFixed(0)+'km (v) x '+(vextent/1000).toFixed(0)+'km (h)'
            }


            //console.log(this.props.doseMapAnalysisInterface)
            //console.log(this.props.doseMap)

            const doseMapSelected = this.props.doseMapAnalysisInterface?.doseMapSelected;
            const doseMapType = this.props.doseMapAnalysisInterface?.doseMapType;
            const doseMapAnalysisType = this.props.doseMapAnalysisInterface?.doseMapAnalysisType;
            const doseMapsAvailableStats = this.props.doseMapAnalysisInterface?.doseMapsAvailableStats;
            //const dosemap = this.props.doseMap;

            let meta_dosemap_title_string = '';
            let meta_dosemap_displayed_string = '';
            let meta_dosemap_statistics = '';
            let meta_dosemap_last_updated = '';
            let meta_cbsigma_title_string = '';
            let meta_cbsigma_time_string = '';
            let meta_cbsigma_release_loc_string = '';
            let meta_cbsigma_agent_id_string = '';
            if(doseMapType && doseMapSelected){
                if(doseMapSelected==='A' || doseMapSelected==='B'){
                    const this_string = this.props.doseMapAnalysisInterface?.doseMapDateSelected[doseMapSelected];
                    if(this_string){
                        meta_dosemap_displayed_string = "Source: "+this_string;
                    }
                } else if (doseMapSelected==='C'){
                    let this_string = "F: "+this.props.doseMapAnalysisInterface?.doseMapDateSelected['A']+"  B: "+this.props.doseMapAnalysisInterface?.doseMapDateSelected['B'] ;
                    if(this_string){
                        meta_dosemap_displayed_string = "Sources: "+this_string;
                    }
                }

                //TYPE
                if(doseMapType===DoseMapTypesEnum.DOSEMAP){
                    meta_dosemap_title_string = 'Dose Rate Map';
                } else if(doseMapType===DoseMapTypesEnum.DOSEMAX){
                    meta_dosemap_title_string = 'Max Dose Rate Map';
                } else if(doseMapType===DoseMapTypesEnum.UNCERTAINTY){
                    meta_dosemap_title_string = 'Uncertainty Map';
                }
                if(doseMapSelected==='C'){
                    let analysis_string = '';
                    if(doseMapAnalysisType === 1){
                        analysis_string = ' [Difference (F-B)]';
                    } else if(doseMapAnalysisType===2){
                        analysis_string = ' [Z-Score (F-B)]';
                    } else if(doseMapAnalysisType===3){
                        let method_str='';
                        if(doseMapType===DoseMapTypesEnum.DOSEMAP){
                            method_str=' Avg(F,B)';
                        } else if(doseMapType===DoseMapTypesEnum.DOSEMAX){
                            method_str=' Max(F,B)';
                        }
                        analysis_string = ' [Combine'+method_str+']';
                    }
                    meta_dosemap_title_string += analysis_string
                    if(doseMapType && doseMapsAvailableStats && doseMapSelected){
                        const lastUpdatedTimeA = doseMapsAvailableStats['A'].lastUpdatedTime;
                        const lastUpdatedTimeB = doseMapsAvailableStats['B'].lastUpdatedTime;
                        meta_dosemap_last_updated = 'Updated '
                        if(lastUpdatedTimeA !== null){
                            const dosemap_dateA= new Date(lastUpdatedTimeA*1000).toLocaleString().replace(',','')
                            meta_dosemap_last_updated += ' F: '+dosemap_dateA;
                        }
                        if(lastUpdatedTimeB !== null){
                            const dosemap_dateB= new Date(lastUpdatedTimeB*1000).toLocaleString().replace(',','')
                            meta_dosemap_last_updated += ' B: '+dosemap_dateB;
                        }
                    }
                } else if(doseMapSelected==='A' || doseMapSelected==='B'){
                    if(doseMapsAvailableStats){
                        const lastUpdatedTime = doseMapsAvailableStats[doseMapSelected].lastUpdatedTime;
                        if(lastUpdatedTime !== null){
                            const dosemap_date= new Date(lastUpdatedTime*1000).toLocaleString().replace(',','')
                            meta_dosemap_last_updated = 'Updated: '+dosemap_date+'  ';
                        }
                    }
                }

            //STAT
                if(doseMapsAvailableStats){
                    const dataScaleVal = doseMapsAvailableStats[doseMapSelected].dataScaleVal[doseMapType]
                    meta_dosemap_statistics += 'Data Statistics: Min: '+dataScaleVal.min+ '   Max:'+dataScaleVal.max
                }
            }

            //CBSIGMA
            let thisCBSigmaOutput;
            if(this.props.cbSigmaArray !== undefined){
                if(this.props.replayTime){
                    thisCBSigmaOutput = this.findCBSigmaAtTime(this.props.replayTime);
                } else {
                    if(this.getInvOngoingCBSIGMA(this.props.investigations).length > 0){
                        thisCBSigmaOutput = this.props.cbSigmaArray[0];
                    }
                }
            }
            if(thisCBSigmaOutput){
                meta_cbsigma_title_string='CB-SIGMA';
                meta_cbsigma_time_string='Contour Time:'+new Date(thisCBSigmaOutput.timestamp).toLocaleString().replace(',','');
                if(thisCBSigmaOutput.releaseLocation !== null)
                    meta_cbsigma_release_loc_string="Est. Release Loc: "+thisCBSigmaOutput.releaseLocation?.latitude.toFixed(6)+','+thisCBSigmaOutput.releaseLocation?.longitude.toFixed(6)
                meta_cbsigma_agent_id_string="Chemical ID: "+thisCBSigmaOutput.agentId
            }

            const addMetaText =() => {
                const voffset = 20
                const hoffset = 5;
                const indent = 2;
                const lineheight = 17
                const columnwidth = mapImg.width/3;
                ctx!.font = 'bold 16px Arial';
                ctx!.fillText("View Extent",hoffset,mapImg.height+voffset, columnwidth)
                ctx!.font = '13px Arial';
                ctx!.fillText(meta_corners_string1,hoffset+indent,mapImg.height+voffset+lineheight*1, columnwidth)
                ctx!.fillText(meta_corners_string2,hoffset+indent,mapImg.height+voffset+lineheight*2, columnwidth)
                ctx!.fillText(meta_map_center,hoffset+indent,mapImg.height+voffset+lineheight*3, columnwidth)
                ctx!.fillText(meta_map_extent,hoffset+indent,mapImg.height+voffset+lineheight*4, columnwidth)

                ctx!.font = 'bold 16px Arial';
                ctx!.fillText(meta_dosemap_title_string,hoffset+columnwidth,mapImg.height+voffset, columnwidth)
                ctx!.font = '13px Arial';
                ctx!.fillText(meta_dosemap_statistics,hoffset+indent+columnwidth,mapImg.height+voffset+lineheight*1, columnwidth)
                ctx!.fillText(meta_dosemap_displayed_string,hoffset+indent+columnwidth,mapImg.height+voffset+lineheight*2, columnwidth)
                ctx!.fillText(meta_dosemap_last_updated,hoffset+indent+columnwidth,mapImg.height+voffset+lineheight*3, columnwidth)

                ctx!.font = 'bold 16px Arial';
                ctx!.fillText(meta_cbsigma_title_string,hoffset+columnwidth*2,mapImg.height+voffset, columnwidth)
                ctx!.font = '13px Arial';
                ctx!.fillText(meta_cbsigma_time_string,hoffset+indent+columnwidth*2,mapImg.height+voffset+lineheight*1, columnwidth)
                ctx!.fillText(meta_cbsigma_agent_id_string,hoffset+indent+columnwidth*2,mapImg.height+voffset+lineheight*3, columnwidth)
                ctx!.fillText(meta_cbsigma_release_loc_string,hoffset+indent+columnwidth*2,mapImg.height+voffset+lineheight*2, columnwidth)

            }

            const colorbarElement = document.getElementById('dose-rate-colorbar');
            const contourkeyElement = document.getElementById('contour-key');

            //Draw map image first
            let canvas = document.createElement('canvas')
            let mapImg = new Image;
            let ctx = canvas.getContext('2d');
            const metadata_height = 100;
            if(mapImg !== null && canvas !== null && ctx !== null){
                mapImg.onload = () => {
                    ctx!.canvas.width  = mapImg.width;
                    ctx!.canvas.height = mapImg.height+metadata_height;
                    ctx!.drawImage(mapImg,0,0);
                    ctx!.font = '12px Arial';
                    ctx!.fillStyle = '#fff';
                    ctx!.fillRect(mapImg.width/4*3,mapImg.height-25,mapImg.width/4, 20);
                    ctx!.fillStyle = '#000';
                    ctx!.fillText(map_attribution,mapImg.width/4*3,mapImg.height-10, mapImg.width/4)
                    addMetaText();

                    const generate_contourkey= new Promise<void>((resolve, reject) => {
                        if(contourkeyElement !== null){
                            htmlToImage.toBlob(contourkeyElement)
                            .then((contourkeyBlob) => {
                                return new Promise<void>((resolve, reject) => {
                                    if(contourkeyBlob !== null){
                                        let contourkeyImg = new Image;
                                        if(contourkeyImg !== null){
                                            contourkeyImg.onload = () => {
                                                ctx!.drawImage(contourkeyImg,mapImg.width/2-contourkeyImg.width/2,mapImg.height-15-contourkeyImg.height);
                                                resolve();
                                            }
                                            contourkeyImg.src = URL.createObjectURL(contourkeyBlob)
                                        } else {
                                            resolve();
                                        }
                                    } else {
                                        resolve();
                                    }
                                });
                            }).finally(()=>resolve())
                        } else {
                            resolve();
                        }
                    });

                    //Colorbar
                    const generate_colorkey= new Promise<void>((resolve, reject) => {
                        if(colorbarElement !== null){
                            htmlToImage.toBlob(colorbarElement)
                            .then((colorbarblob) => {
                                return new Promise<void>((resolve, reject) => {
                                    if(colorbarblob !== null){
                                        let colorbarImg = new Image;
                                        if(colorbarImg !== null){
                                            colorbarImg.onload = () => {
                                                ctx!.drawImage(colorbarImg,mapImg.width-colorbarImg.width-5,5);
                                                resolve();
                                            }
                                            colorbarImg.src = URL.createObjectURL(colorbarblob)
                                        } else {
                                            resolve();
                                        }
                                    } else {
                                        resolve();
                                    }
                                });
                            }).finally(()=>resolve())
                        } else {
                            resolve();
                        }
                    });

                    //Call everything
                    generate_contourkey
                        .then(()=>generate_colorkey)
                        .then(()=>saveImage());


                }
                mapImg.src = URL.createObjectURL(mapblob)
            }
        }   //END OF exportOnlyCallback


        const PrintControl:any = reactleaflet.withLeaflet(PrintControlDefault);

        const printControlDisplay =
            <PrintControl ref="map" position="topleft" sizeModes={['Current']} hideControlContainer={true} title="Export as PNG" exportOnly
                exportOnlyCallback={printControlCallback}/>

            const thisControl =
                <Control position="topleft" >
                    <button className={'leaflet-custom-control-button'} onClick={ () => {
                            const this_map = this.map_element.current.leafletElement as L.Map;  //N.B. THIS IS HOW YOU GET MAP FROM MAP REFERENCE!!!!!!!!! **IMPORTANT**
                            this_map.fitBounds(this.calculateBoundsFromSensor(),{maxZoom:17})
                        }}
                        title={'Fit All Nodes In View'}>
                        <img src={map_fit_all} style={{height:'26px',width:'26px'}}/>
                    </button>
                </Control>

                //console.log(this.map_center)

                let darkMapMode;
                if(this.state.map_mode_day !== true){
                    darkMapMode = "darkmapmode";
                }
        return (
            <>
                <div style={{ display: 'flex', position: 'relative', justifyContent: 'flexEnd' }}>
                    <div style={{ display: 'flex', position: 'relative', justifyContent: 'flexEnd' }}>
                        {unselectButton}
                    </div>
                </div>
                <reactleaflet.Map center={this.map_center} zoom={zoom_level} animate={true} onDragStart={this.enableRecenterButton.bind(this)} tap={true} drag={true}
                    onZoomEnd={this.getZoom.bind(this)} maxZoom={19} minZoom={3} touchZoom={zoom_behavior} scrollWheelZoom={scrollwheel_zoom_behavior} ref={this.map_element} style={{ backgroundColor: background_color }}>
                    <reactleaflet.TileLayer
                        key={'TilelayerKey'+darkMapMode}
                        url={map_url}
                        attribution={map_attribution}
                        className={darkMapMode}
                    />
                    {thisControl}
                    {printControlDisplay}
                    {doseMapOverlay}
                    {bioInvestigationMarkerDisplay}
                    {cbsigma_contours}
                    {cbsigma_release_loc}
                    {current_locations}
                </reactleaflet.Map>
                <div style={{ display: 'flex', position: 'relative', justifyContent: 'spaceBetween', bottom: '15px' }}>
                    {recenterButton}
                </div>
                <div style={{ display: 'flex', position: 'relative', justifyContent: 'flexEnd', bottom: '15px', minWidth:'300px'}}>
                    {cbsigma_contour_key}
                    <div style={{ display: 'flex', position: 'absolute', right: '0px', bottom: '2px', padding: '5px' }}>
                        {mapModeButton}
                        {recenterOnAlertButton}
                    </div>
                </div>

                {/*HIDDEN DIVS FOR EXPERT SETTINGS*/}

                <div className={"map-select-day-map-simple-hidden"} style={{display:'none'}} onClick={()=>{this.handleDayMapTypeClick(true)}}/>
                <div className={"map-select-day-map-detailed-hidden"} style={{display:'none'}} onClick={()=>{this.handleDayMapTypeClick(false)}}/>
            </>
        )

    }
}
export default MultiSensorMapDisplay

/******************************************************************************/

export interface MultiPositionMarkerDisplayProps {
    locations: {[key:string]:SensorPosition} | undefined,
    mapModeDay: boolean
}

export class MultiPositionMarkerDisplay extends React.Component<MultiPositionMarkerDisplayProps> {
    render() {
        let position_markers: JSX.Element[] = [];

        if (this.props.locations !== undefined) {
            Object.values(this.props.locations).forEach((loc) => {
                if(loc.latitude !== null && loc.longitude !== null){
                    let position_icon;
                    let logo;
                    if (this.props.mapModeDay) {
                        logo = location_circle_logo;
                    } else {
                        logo = location_circle_white_logo;
                    }
                    position_icon = L.divIcon({
                        className: 'leaflet-div-icon-clear',
                        html:
                            '<div id="map_vehicle_icon" style="opacity:0.6;"><img src="' + logo + '"></div>',
                        iconSize: [32, 32],
                        iconAnchor: [17, 17],
                    });

                    const key = loc.device; //+'_'+loc.timestamp.toFixed();
                    const position_marker =
                        <reactleaflet.Marker position={[loc.latitude, loc.longitude]}
                            icon={position_icon}
                            data={key}
                            key={key}>
                            <reactleaflet.Popup>
                                {loc.device}
                            </reactleaflet.Popup>
                        </reactleaflet.Marker>
                    position_markers.push(position_marker);
                }
            });
        }
        return (
            position_markers
        )
    }
}

/******************************************************************************/

export interface BioInvestigationMarkerDisplayProps {
    investigations: Investigation[],
    selectedInvestigation?: Investigation,
    investigationInterface: InvestigationInterface,
}

export class BioInvestigationMarkerDisplay extends React.Component<BioInvestigationMarkerDisplayProps> {
    constructor(props: BioInvestigationMarkerDisplayProps) {
        super(props)

        this.handleSelectClick = this.handleSelectClick.bind(this);
        this.getPinImg = this.getPinImg.bind(this);
    }

    handleSelectClick(event: React.MouseEvent<HTMLElement>) {
        let marker = event.target as any;
        this.props.investigationInterface.select(marker.options.data);
    }

    getPinImg(inv: Investigation) {
        let img = null
        img = pin_generic_gray_logo;
        if('type' in inv){
            if(inv.type === messages.Encounter.EncounterType.BIOSIGMA || messages.Encounter.EncounterType.BIO){
                img = pin_biological_logo;
            } else if(inv.type === messages.Encounter.EncounterType.CHEMSIGMA || inv.type === messages.Encounter.EncounterType.CHEM){
                    img = pin_chemical_logo;
            } else if (inv.type === messages.Encounter.EncounterType.RN_FUSION || inv.type === messages.Encounter.EncounterType.RAD){
                if (inv.isotopes.length > 0) {
                    if (inv.isotopes[0].category.toUpperCase() === 'MEDICAL') {
                        img = pin_medical_logo;
                    }
                    if (inv.isotopes[0].category.toUpperCase() === 'INDUSTRIAL') {
                        img = pin_industrial_logo;
                    }
                    if (inv.isotopes[0].category.toUpperCase() === 'RDD') {
                        img = pin_industrial_logo;
                    }
                    if (inv.isotopes[0].category.toUpperCase() === 'SNM') {
                        img = pin_nuclear_logo;
                    }
                    if (inv.isotopes[0].category.toUpperCase() === 'NUCLEAR') {
                        img = pin_nuclear_logo;
                    }
                    if (inv.isotopes[0].category.toUpperCase() === 'NORM') {
                        img = pin_norm_logo;
                    }
                } else {
                    img = pin_generic_logo;
                }
            }
        }
        /*
        if (inv.isotopes.length > 0) {
            if (inv.isotopes[0].category.toUpperCase() === 'MEDICAL') {
                img = pin_medical_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'INDUSTRIAL') {
                img = pin_industrial_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'RDD') {
                img = pin_industrial_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'SNM') {
                img = pin_nuclear_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'NUCLEAR') {
                img = pin_nuclear_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'NORM') {
                img = pin_norm_logo;
            }
        } else {
            img = pin_generic_logo;
        }
        */
        return (img);
    }

    render() {
        //Investigation Markers
        let markers: JSX.Element[] = [];
        this.props.investigations.forEach((inv) => {
            const key = uuidToString(inv.id);

            let opacity = '0.8';
            if (this.props.selectedInvestigation && inv.id !== this.props.selectedInvestigation.id) {
                opacity = '0.1';
            }

            let visibility_active_badge = 'visible';
            if (inv.finalized) {
                visibility_active_badge = 'hidden';
            }
            let visibility_network_badge = 'hidden';
            if ('type' in inv){
                if (inv.type === messages.Encounter.EncounterType.BIOSIGMA ||
                    inv.type === messages.Encounter.EncounterType.CHEMSIGMA  ||
                    inv.type === messages.Encounter.EncounterType.RN_FUSION) {
                    visibility_network_badge = 'visible';
                }
            }
            const markerIcon = L.divIcon({
                className: 'leaflet-div-pin-icon-clear',
                html:
                    '<div id="inv_' + key + '">' +
                    '<img src="' + pin_shadown_logo + '" style="position:absolute; opacity:' + opacity + '; transition: all 0.5s; left:3px; bottom:-1px"></div>' +
                    '<img src="' + this.getPinImg(inv) +
                    '" style="position:relative; opacity:' + opacity + '; transition: all 0.5s" width="32" height="48">' +
                    '<img class="map-pin-active-badge" src="' + active_badge_logo +
                    '" style="visibility:' + visibility_active_badge +
                    ';position:absolute; opacity:' + opacity + '; transition: all 0.5s; left: 6px; bottom:48px" width="20" height="20">' +
                    '<img class="map-pin-active-badge" src="' + network_alert_logo +
                    '" style="visibility:' + visibility_network_badge +
                    ';position:absolute; opacity:' + opacity + '; transition: all 0.5s; left: 22px; bottom:33px" width="18" height="18">' +
                    '</div>',
                iconSize: [32, 48],
                iconAnchor: [15, 47],
            });
            if ('type' in inv){
                if(inv.type === messages.Encounter.EncounterType.BIOSIGMA ||
                    inv.type === messages.Encounter.EncounterType.CHEMSIGMA ||
                    inv.type === messages.Encounter.EncounterType.RN_FUSION){
                    if(inv.source_location !== null){
                        if (inv.source_location.latitude !== null && inv.source_location.longitude !== null) {
                            const marker =
                                <reactleaflet.Marker position={[inv.source_location.latitude, inv.source_location.longitude]}
                                    icon={markerIcon}
                                    data={inv}
                                    selected={this.props.selectedInvestigation && inv.id === this.props.selectedInvestigation.id}
                                    onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => this.handleSelectClick(event)}
                                    key={key}>
                                </reactleaflet.Marker>
                            markers.push(marker);
                        }
                    }
                /*
                } else if(inv.type === messages.Encounter.EncounterType.RN_FUSION){
                        if(inv.source_location !== null){
                            if (inv.source_location.latitude !== null && inv.source_location.longitude !== null) {
                                var marker =
                                    <Marker position={[inv.source_location.latitude, inv.source_location.longitude]}
                                        icon={markerIcon}
                                        data={inv}
                                        selected={this.props.selectedInvestigation && inv.id === this.props.selectedInvestigation.id}
                                        onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => this.handleSelectClick(event)}
                                        key={key}>
                                    </Marker>
                                markers.push(marker);
                            }
                        }
                */
                } else {
                    if(inv.vehicle_location !== null){
                        if (inv.vehicle_location.latitude !== null && inv.vehicle_location.longitude !== null) {
                            const marker =
                                <reactleaflet.Marker position={[inv.vehicle_location.latitude, inv.vehicle_location.longitude]}
                                    icon={markerIcon}
                                    data={inv}
                                    selected={this.props.selectedInvestigation && inv.id === this.props.selectedInvestigation.id}
                                    onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => this.handleSelectClick(event)}
                                    key={key}>
                                </reactleaflet.Marker>
                            markers.push(marker);
                        }
                    }
                }
            }
        });

        return (
            markers
        )
    }
}
/******************************************************************************/
export interface CBSigmaContourDisplayProps {
    cbSigmaOutput?: CBSigmaOutput
}

export class CBSigmaContourDisplay extends React.Component<CBSigmaContourDisplayProps> {

    static getContourColor(concentration:number, isChem?:boolean){
        if(isChem){
            switch(concentration){
                case 0.01:
                    return "blue";

                case 0.1:
                    return "goldenrod";

                case 1:
                    return "red";

                case 10:
                    return "darkred";

                default:
                    return "gray";
            }
        } else {
            switch(concentration){
                case 10:
                    return "blue";

                case 100:
                    return "goldenrod";

                case 1000:
                    return "red";

                case 10000:
                    return "darkred";

                default:
                    return "gray";
            }
        }
    }

    static isChemBasedOnCBSigmaOutput(cbSigmaOutput?:CBSigmaOutput){
        let isChem = false;
        if(cbSigmaOutput){
            /*
            if(cbSigmaOutput.agentId === "BIO"){
                isChem = false;
            } else {
                isChem = true;
            }
            */

            if(cbSigmaOutput.contourLevels !== null){
                cbSigmaOutput.contourLevels.forEach(thisLevel => {
                    if(thisLevel.concentration < 1)
                        isChem = true;
                });
            }

        }
        return isChem;
    }

    render() {

        const isChem = CBSigmaContourDisplay.isChemBasedOnCBSigmaOutput(this.props.cbSigmaOutput);
        let contourLayers;
        let polygons:JSX.Element[] = [];
        if(this.props.cbSigmaOutput){
            if(this.props.cbSigmaOutput.contourLevels !== undefined &&
                this.props.cbSigmaOutput.contourLevels !== null &&
                this.props.cbSigmaOutput.contourLevels.length > 0){
                const levelSortedContourLevels = this.props.cbSigmaOutput.contourLevels.sort((lhs, rhs) => rhs.concentration - lhs.concentration);
                let prevContourLevel:messages.CBSigmaReport.ContourLevel | undefined = undefined;
                levelSortedContourLevels.forEach((thisContourLevel:messages.CBSigmaReport.ContourLevel,idx) => {
                    let contour_latlng: L.LatLngExpression[][] = [];
                    if(thisContourLevel.contours !== undefined && thisContourLevel.contours !== null && thisContourLevel.contours.length > 0){
                        thisContourLevel.contours.forEach((thisContour:messages.CBSigmaReport.Contour) =>{
                            let outer_latlng: L.LatLngExpression[] = [];
                            if(thisContour.contour_outer){
                                //console.log('Outer contour')
                                thisContour.contour_outer.points.forEach((point:messages.Rad.Location) =>{
                                    const thisPoint: L.LatLngExpression = [point.latitude,point.longitude];
                                    outer_latlng.push(thisPoint)
                                })
                                contour_latlng.push(outer_latlng);
                            }
                            if(thisContour.contour_inner !== undefined && thisContour.contour_inner !== null && thisContour.contour_inner.length > 0){
                                thisContour.contour_inner.forEach((thisHole:messages.CBSigmaReport.Polygon) =>{
                                    //console.log('Inner contour')
                                    let inner_latlng:L.LatLngExpression[] = [];
                                    thisHole.points.forEach((point:messages.Rad.Location) =>{
                                        const thisPoint: L.LatLngExpression = [point.latitude,point.longitude];
                                        inner_latlng.push(thisPoint)
                                    })
                                    contour_latlng.push(inner_latlng)
                                });

                            }

                        });
                    }
                    //
                    if(prevContourLevel){
                        prevContourLevel.contours.forEach((thisContour:messages.CBSigmaReport.Contour) =>{
                            let outer_latlng: L.LatLngExpression[] = [];
                            if(thisContour.contour_outer){
                                //console.log('Outer contour')
                                thisContour.contour_outer.points.forEach((point:messages.Rad.Location) =>{
                                    const thisPoint: L.LatLngExpression = [point.latitude,point.longitude];
                                    outer_latlng.push(thisPoint)
                                })
                                contour_latlng.push(outer_latlng);
                            }
                        });
                    }
                    let polygon = <reactleaflet.Polygon key={thisContourLevel.timestamp+'_'+idx} positions={contour_latlng} color={CBSigmaContourDisplay.getContourColor(thisContourLevel.concentration,isChem)} weight={2.0} fillOpacity={0.55}/>
                    polygons.unshift(polygon);

                    prevContourLevel = thisContourLevel;
                });
            }
        }

        return(
            <>
                {polygons}
            </>
        )
    }

}
/******************************************************************************/
export interface CBSigmaReleaseLocDisplayProps {
    cbSigmaOutput?: CBSigmaOutput
    darkmap?: boolean
}

export class CBSigmaReleaseLocDisplay extends React.Component<CBSigmaReleaseLocDisplayProps> {


    render() {
        let estimated_release_loc_icon = estimated_release_loc_logo;
        if(this.props.darkmap){
            estimated_release_loc_icon = estimated_release_loc_white_logo;
        }

        const releaseLocMarkerIcon = L.divIcon({
                                className: 'leaflet-div-icon-clear',
                                html:
                                    //'<div class="map_est_release_loc_icon" style="opacity:0.6;">&times;</div>',
                                    '<div id="map_est_release_loc_icon" style="opacity:0.6;"><img src="' + estimated_release_loc_icon + '" height=20 width=20></div>',
                                iconSize: [32, 32],
                                iconAnchor: [17, 17],
                            });

        const releaseLocLat = this.props.cbSigmaOutput?.releaseLocation?.latitude;
        const releaseLocLon = this.props.cbSigmaOutput?.releaseLocation?.longitude;
        let releaseLocMarker;
        if(releaseLocLat && releaseLocLon){
            const key = this.props.cbSigmaOutput?.timestamp
            releaseLocMarker =
                            <reactleaflet.Marker position={[releaseLocLat, releaseLocLon]}
                                icon={releaseLocMarkerIcon}
                                data={key}
                                key={key}>
                            </reactleaflet.Marker>
        }
        return (
            <>
                {releaseLocMarker}
            </>
        )

    }
}
/******************************************************************************/
export interface CBSigmaContourKeyDisplayProps {
    cbSigmaOutput?: CBSigmaOutput
    levels?: number[];
    darkmap?: boolean;
}

export class CBSigmaContourKeyDisplay extends React.Component<CBSigmaContourKeyDisplayProps> {


    render() {
        const estimatedReleaseTimestamp = this.props.cbSigmaOutput?.estimatedReleaseTimestamp;
        const isChem = CBSigmaContourDisplay.isChemBasedOnCBSigmaOutput(this.props.cbSigmaOutput);
        let contourLevels = this.props.levels ? this.props.levels : isChem ? [0.01,0.1,1,10]:[10,100,1000,10000];
        let concentration_title = isChem ? "Concentration [mg/m\u00B3]" : "Concentration [Particles/L]"
        let contour_key:JSX.Element[] = [];
        contourLevels.forEach((level,idx) => {
            const background_color = CBSigmaContourDisplay.getContourColor(level,isChem);
            const this_contour_key =
                <div key={idx} className="contour-key-element">
                    <div className={"contour-key-indicator"} style={{backgroundColor:background_color}}></div> <div style={{ width: '5px' }}></div>{level}
                </div>
                contour_key.push(this_contour_key);
        });



        let estimated_release_loc_icon = estimated_release_loc_logo;
        if(this.props.darkmap){
            estimated_release_loc_icon = estimated_release_loc_white_logo;
        }
        let estimatedReleaseTime;
        if(estimatedReleaseTimestamp){
            const thisTimestampAsDate = new Date(estimatedReleaseTimestamp*1000)
            const timeago = <TimeAgo lastEvent={thisTimestampAsDate} type={'inv'} />
            estimatedReleaseTime =
                <div style={{ display: 'flex', flexDirection:'row', width:'200px'}}>
                    {thisTimestampAsDate.toLocaleDateString() + " " + thisTimestampAsDate.toLocaleTimeString()+" "}
                </div>
        } else {
            estimatedReleaseTime =
                <div style={{ display: 'flex', flexDirection:'row', width:'200px'}}>
                    N/A
                </div>
        }

        return (
            <div className="contour-key-background" style={{ display: 'flex', position: 'absolute', left: '30%', bottom: '7px', height:'54px',flexDirection:'row', alignItems:'flex-start' }}>
                <div id="contour-key" className="contour-key">
                    <div className="contour-key-component" style={{ display: 'flex', flexDirection:'column', alignItems:'flex-start' }}>
                        <label className="metric-title" style={{display:'flex', paddingLeft:'12px', color:'white'}}>{concentration_title}</label>
                        <div className="contour-key-component" style={{ display: 'flex', flexDirection:'row' }}>
                            {contour_key}
                        </div>
                    </div>
                    <div className="contour-key-component" style={{ display: 'flex', flexDirection:'column', alignItems:'flex-start' }}>
                        <label className="metric-title" style={{display:'flex', paddingLeft:'12px',color:'white'}}>Estimated Release Time</label>
                        <div key={"releasetime"} className="contour-key-element" >
                            <img src={estimated_release_loc_icon} style={{height:'20px',width:'20px', paddingRight:'5px',paddingLeft:'5px',paddingTop:'3px'}}/>
                            <div style={{ display: 'flex', flexDirection:'column', justifyContent:'left'}}>
                                <div style={{ display: 'flex', flexDirection:'row', width:'200px'}}>
                                    {estimatedReleaseTime}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

/******************************************************************************/
/*
export interface DoseTrailDisplayProps {
    positions: messages.Core.GPSReading[],
    radiationData: messages.Rad.RadiationReading[],
    plotSince: number
}

export class DoseTrailDisplay extends React.Component<DoseTrailDisplayProps> {
    dose_min: number = 1.e8;
    dose_max: number = 0.0;
    dose_ave: number = 0;
    dose_range: number = 0;
    dose = 0.0;
    constructor(props: DoseTrailDisplayProps) {
        super(props)

        this.doseColorMap = this.doseColorMap.bind(this);
        this.doseRateFeatureStyle = this.doseRateFeatureStyle.bind(this);
    }
    //GEOJSON STYLE
    doseColorMap(counts: number, ave_counts: number, min_counts: number, count_range: number) {
        if (counts === 0) {
            return 'rgb(0,0,0)';
        } else if (counts < ave_counts) {
            return 'rgb(0,0,' +
                Math.floor((counts - min_counts) / count_range * 255) + ')';
        } else {
            return 'rgb(0,' +
                Math.floor((counts - ave_counts) / count_range * 255) +
                ',255)';
        }
    }

    doseRateFeatureStyle = (feature: any) => {
        return {
            color:
                this.doseColorMap(feature.properties.counts, this.dose_ave, this.dose_min, this.dose_range),
            opacity: 1,
            weight: 5
        };
    };

    render() {
        //Dose Lines
        var ndoses = 0, dose_sum = 0.0;
        this.dose_min = 1.e8;
        this.dose_max = 0.0;
        this.dose_ave = 0;
        this.dose_range = 0;
        this.dose = 0.0;
        var dose_lines: geojson.Feature[] = [];
        //var poly_lines: L.LatLngExpression[] = [];
        var prev_position: number[] | null = null;
        this.props.positions.forEach((gps_reading) => {
            var time = gps_reading.time;
            var position = [gps_reading.lon, gps_reading.lat];
            var dose = 0.0;
            if( time > this.props.plotSince){
                if (this.props.radiationData !== null) {
                    if (this.props.radiationData.length > 0) {
                        var match_idx: number | null = null;
                        var prev_diff: number | null = null;
                        this.props.radiationData.forEach((rad_reading, idx) => {
                            var this_diff = rad_reading.time - gps_reading.time;
                            if (prev_diff != null) {
                                if (this_diff <= 0) {
                                    //Difference Negative=>GPS time is newer
                                    if (this_diff > prev_diff) {
                                        //current is newer than prev without being newer than GPS
                                        if (Math.abs(this_diff) < 10000) {
                                            match_idx = idx;
                                        }
                                    }
                                }
                            } else {
                                prev_diff = this_diff;
                            }
                        });

                        if (match_idx != null) {
                            var sum_count = 0;
                            var sum_dose = 0;
                            this.props.radiationData[match_idx].detectors.forEach((det) => {
                                det.spectrum.forEach((count) => {
                                    sum_count += count;
                                });
                                sum_dose += det.dose_rate;
                            })

                            dose = sum_count;
                            dose_sum += dose;
                            this.dose_min = Math.min(this.dose_min, dose);
                            this.dose_max = Math.max(this.dose_max, dose);
                            ndoses += 1;
                        } else {
                            dose = 0;
                        }
                    }
                }

                if (prev_position !== null) {
                    var new_feature: geojson.Feature = {
                        "type": "Feature",
                        "properties": { "time": time, "counts": dose },
                        "geometry": {
                            "type": "LineString",
                            "coordinates": [prev_position, position]
                        }
                    };
                    dose_lines.push(new_feature);
                }
                prev_position = position;
            }

        });
        if (ndoses > 0) {
            this.dose_ave = dose_sum / ndoses;
            this.dose_range = Math.max(this.dose_max - this.dose_ave, this.dose_ave - this.dose_min);
        } else {
            this.dose_ave = 0;
            this.dose_range = 0;
        }
        var key = new Date().getTime(); //Change in key triggers the GeoJSON redraw

        return (
            <GeoJSON key={key} data={dose_lines} style={this.doseRateFeatureStyle} />
        )

    }

}
*/
